<template>
    <v-layout>
        <v-dialog v-model="infoDialog" width="auto">
            <v-card class="pa-3">
                <v-card-title class="pt-2 pl-1 pb-1 pl-7">
                    <span class="text-h5">{{ $t('menu.info') }}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="font16 px-7 py-2" v-html="$t('agent.depositNotification')"></v-card-text>

                <v-card-actions class="pr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn tag="a" color="lightBlack" text @click="infoDialog = false">
                        {{ $t('action.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuAccountDepositDialog',

        data() {
            return {
                infoDialog: false,
            };
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            open() {
                this.infoDialog = true;
            },
        },

        computed: {
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
